// components/CommonTableToolbarActions.tsx
import { Box } from '@mui/material';
import { MRT_ToggleFiltersButton, MRT_ToggleFullScreenButton } from 'material-react-table';
import { TableColumnVisibilityMenu } from './TableColumnVisibilityMenu'; // adjust path as needed

interface CommonToolbarInternalActionsProps {
    table: any; 
}

export const CommonToolbarInternalActions = ({ table }: CommonToolbarInternalActionsProps) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <MRT_ToggleFiltersButton table={table} />
            <TableColumnVisibilityMenu table={table} />
            <MRT_ToggleFullScreenButton table={table} />
        </Box>
    );
};